// Utils
import { hasLocalStorage } from "utils/common"

export const setLocalStorage = (key: string, payload: any) => {
  if (!hasLocalStorage()) {
    return false
  }

  localStorage.setItem(key, JSON.stringify(payload))

  return true
}

export const getLocalStorage = (key: string) => {
  if (!hasLocalStorage()) {
    return null
  }

  const data = localStorage.getItem(key)

  if (!data) return null

  return JSON.parse(data)
}

export const clearLocalStorage = (key: string) => {
  localStorage?.removeItem(key)
}
